export default "__VITE_ASSET__7AOIf$SW__"